// Content reports (takedown queue). Anyone signed in can file one; only admins
// read and triage them (see firestore.rules + AdminPanel).
import { db, functions } from './firebase';
import {
  collection, getDocs, query, where, doc, updateDoc, deleteDoc,
} from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

// Written server-side (submitReport callable: requires sign-in, rate-limited,
// reporter identity from auth). `reporter` is ignored now; kept for callers.
export async function submitReport({ target, tileId = null, reason, targetType = 'profile' }) {
  const submit = httpsCallable(functions, 'submitReport');
  return submit({ targetUid: target.uid, targetUsername: target.username || '', tileId, reason, targetType });
}

// Admin: mark a report upheld or dismissed (dismissals feed reporter trust).
export async function reviewReport(id, outcome) {
  const fn = httpsCallable(functions, 'reviewReport');
  return fn({ id, outcome });
}

// Admin: open reports, newest first (sorted client-side to avoid a composite index).
export async function getOpenReports() {
  const q = query(collection(db, 'reports'), where('status', '==', 'open'));
  const snap = await getDocs(q);
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

export async function resolveReport(id) {
  return updateDoc(doc(db, 'reports', id), { status: 'resolved' });
}

export async function deleteReport(id) {
  return deleteDoc(doc(db, 'reports', id));
}
